import {
  type Option,
  UtilitySelect,
  Icon,
  useTheme,
} from '@quickbit/qb-design-system';
import { capitalize } from 'lodash';
import { useAsync } from 'react-use';
import { getMerchantList } from 'tabs/api';

export interface MerchantOption extends Option {
  allowProcessingOrders?: boolean;
}

interface Props {
  merchant: MerchantOption | MerchantOption[] | null;
  setMerchant: (data: MerchantOption | MerchantOption[] | null) => void;
  searchable?: boolean;
  multiple?: boolean;
}

export const MerchantSelect = ({
  merchant,
  setMerchant,
  searchable = true,
  multiple,
}: Props) => {
  const { palette } = useTheme();
  const { value, loading } = useAsync(async () => {
    const data = await getMerchantList();
    return data.map((merchant) => ({
      value: merchant.uuid || '',
      label: merchant.name,
      allowProcessingOrders: merchant.config.allowProcessingOrders,
    }));
  });
  if (loading)
    return (
      <Icon
        name="spinner"
        className={{ svg: { color: palette.grey.default } }}
      />
    );

  return (
    <UtilitySelect
      label={
        !merchant || (Array.isArray(merchant) && merchant.length === 0)
          ? 'Merchant'
          : Array.isArray(merchant)
          ? merchant.length === 1
            ? merchant[0].label
            : `Merchants (${merchant.length})`
          : // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          merchant
          ? capitalize(merchant.label)
          : 'Merchant'
      }
      listTitle="Merchants"
      options={value ?? []}
      value={merchant}
      onSelect={setMerchant}
      searchable={searchable}
      multiple={multiple}
    />
  );
};
